import { render } from "./ClientAiChat.vue?vue&type=template&id=869da7bc&scoped=true"
import script from "./ClientAiChat.vue?vue&type=script&lang=js"
export * from "./ClientAiChat.vue?vue&type=script&lang=js"

import "./ClientAiChat.vue?vue&type=style&index=0&id=869da7bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869da7bc"]])

export default __exports__